import { mergeStyles } from '../../../../internal/utils/mergeStyles';
import * as mainStyles from './styles.module.css';
import { getThemeStyles } from './theme';
export function getStyles(theme) {
  var themeStyles = getThemeStyles(theme);
  return mergeStyles(mainStyles, themeStyles);
}